import axios from "axios";
import CustomInterceptors from "@/api/Auth/GAInterceptors";

const InstanceAllRisk = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

InstanceAllRisk.interceptors.request.use(CustomInterceptors.GAInterceptors);

InstanceAllRisk.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default InstanceAllRisk;